module.exports = __webpack_public_path__ + "static/img/soccer.2ec1637.jpg";